import React from 'react';
import { VideoPlugin } from './VideoPlugin';
import styled from 'styled-components';

import WinVideoMp4 from './videos/pull-off/win.mp4';
import LoseVideoMp4 from './videos/pull-off/lose.mp4';
import LandingVideoMp4 from './videos/pull-off/landing.mp4';

import { IProps } from '../../common-types/Prop';

export const VideoContainer = styled.div`
  margin-top: 31.7vh;
  position: relative;
  display: inline-block;
  width: 65.7vw;
  overflow: hidden;
  height: 46.3vh;
`;
VideoContainer.displayName = 'VideoContainer';

export const PullOffPlugin: React.FunctionComponent<IProps> = (props) => (
  <VideoPlugin
    {...props}
    winVideo={{ mp4: WinVideoMp4 }}
    loseVideo={{ mp4: LoseVideoMp4 }}
    landingVideo={{ mp4: LandingVideoMp4 }}
    VideoWrapper={VideoContainer}
  />
);